(function() {
  const productPropertiesCache = new Map();
  let cartDrawer;
  let timeoutId = null;

  function setMoastSubmitButtonLoading(loading) {
    const quickAddElement = document.querySelector('moast-quick-add');
    const submitButton = quickAddElement?.shadowRoot?.querySelector('button[type="submit"]');

    if (!submitButton) return;

    
    submitButton.classList.toggle('loading', loading);
    submitButton.disabled = loading;

    const styleId = 'moast-atc-loading-styles';
    const existingStyle = quickAddElement.shadowRoot.getElementById(styleId);
    if (existingStyle && quickAddElement.shadowRoot.contains(existingStyle)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .atc.loading {
        color: transparent;  
        position: relative;
      }
      .atc.loading::after {
        content: "…";    
        color: inherit;         
        position: absolute;
        left: 0;
        right: 0;
        text-align: center;
        color: var(--moast-button-color-contrast-disabled);
      }
    `;
    
    quickAddElement.shadowRoot.appendChild(style);
  }

  function setMoastPlayerZIndex() {
    const moastPlayer = document.querySelector('moast-player');
    moastPlayer && moastPlayer.style.setProperty('--moast-z-index', '999');
  }

  function hideMoastQuickAddToast() {
    const quickAddElement = document.querySelector('moast-quick-add');
    const toast = quickAddElement?.shadowRoot?.querySelector('.toast');
    toast && toast.style.setProperty('display', 'none');
  }

  function closeMoastQuickAdd() {
    const quickAddElement = document.querySelector('moast-quick-add');
    const closeButton = quickAddElement?.shadowRoot?.querySelector('button.close');
    closeButton && closeButton.click();
  }

  async function updateCartItemProperties(product, variantId) {
    try {
      const [cart, properties] = await Promise.all([
        getCart(),
        getProductProperties(product, variantId)
      ]);

      const cartItem = cart?.items?.find(item => item.id === variantId);

      if (!cartItem) {
        console.warn(`Cart item with variantId ${variantId} not found`);
        return;
      }

      const igItemProperty = window.igCustomData?.itemProperty;

      const item = {
        id: cartItem.key,
        quantity: cartItem.quantity,
        properties: {
          ...cartItem.properties || {},
          ...properties || {},
          ...igItemProperty || {},
        },
      };
      
      await updateCart(item);
    } catch (error) {
      console.error('Error updating cart item properties:', error);
    }
  }

  async function updateCart(itemCart) {
    const sections = cartDrawer.getSectionsToRender();
    const sectionIds = sections.map(section => section.id).join(',');
    const cartMutationStamp = typeof markCartMutationStamp === 'function'
      ? markCartMutationStamp()
      : (window._CART_MUTATION_STAMP = (window._CART_MUTATION_STAMP || 0) + 1);

    const item = {
      ...itemCart,
      sections: sectionIds,
      sections_url: window.location.pathname
    }

    const response = await fetch(`${routes.cart_change_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(item),
    });

    if (!response.ok) {
      throw new Error(`Failed to update cart: ${response.status} ${response.statusText}`);
    }

    const responseData = await response.json();
    responseData._cartMutationStamp = cartMutationStamp;
    cartDrawer.renderContents(responseData, 'default');
    cartDrawer.classList.remove('is-empty');
  }

  async function getCart() {
    if (window._cartState && Array.isArray(window._cartState.items)) return window._cartState;
    if (typeof fetchCartJson === 'function') {
      const cart = await fetchCartJson();
      if (cart) return cart;
    }

    throw new Error('Cart state is unavailable');
  }

  async function getProductProperties(product, variantId) {
    const cacheKey = `${product}_${variantId}`;
    
    if (productPropertiesCache.has(cacheKey)) {
      return productPropertiesCache.get(cacheKey);
    }
    
    const response = await fetch(`/products/${product}?variant=${variantId}&view=properties`);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch product properties: ${response.status} ${response.statusText}`);
    }
    
    const text = await response.text();
    
    try {
      const properties = JSON.parse(text);
      productPropertiesCache.set(cacheKey, properties);
      return properties;
    } catch (parseError) {
      console.error('Error parsing product properties JSON:', parseError);
      return {};
    }
  }

  function openCartDrawer() {
    cartDrawer.open();
  }

  async function updateCartDrawer() {
    await cartDrawer.update();
  }

  async function handleCartAdd(event) {
    const { product, variantId } = event.detail;
    if (!product || !variantId) return;

    timeoutId && clearTimeout(timeoutId);
    setMoastSubmitButtonLoading(true);
    hideMoastQuickAddToast();
    setMoastPlayerZIndex();
    await updateCartItemProperties(product, variantId);
    closeMoastQuickAdd();
    setMoastSubmitButtonLoading(false);
    timeoutId = setTimeout(openCartDrawer, 400);
  }
  
  function init() {
    cartDrawer = document.querySelector('cart-drawer');
    if(!cartDrawer) {
      return;
    }
    document.addEventListener('moast-cart-add', handleCartAdd);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
